// TODO: this page is almost exact copy of the blog index. Sure we can merge them.

import siteMetadata from "@/data/siteMetadata";
import { getAllFilesFrontMatter } from "@/lib/mdx";
import { BlogList } from "@components/blog/BlogList";
import { PageSEO } from "@components/blog/SEO";
import { CTASection } from "components/platform/CTASection";
import Layout from "components/platform/Layout";
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from "next";
import { ReactElement } from "react";
import { PostFrontMatter } from "types/PostFrontMatter";
import { POSTS_PER_PAGE } from "..";

export const getStaticPaths: GetStaticPaths<{ page: string }> = async () => {
  const allPosts = await getAllFilesFrontMatter("blog");
  const posts = allPosts.filter((post) => post.listed !== false);

  const totalPages = Math.ceil(posts.length / POSTS_PER_PAGE);
  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { page: (i + 1).toString() },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<{
  posts: PostFrontMatter[];
  initialDisplayPosts: PostFrontMatter[];
  pagination: { currentPage: number; totalPages: number };
}> = async (context) => {
  const {
    params: { page },
  } = context as { params: any }; // TODO: Check if params can ever be non-optional
  const allPosts = await getAllFilesFrontMatter("blog");
  const posts = allPosts.filter((post) => post.listed !== false);
  const pageNumber = parseInt(page as string);
  const initialDisplayPosts = posts.slice(
    POSTS_PER_PAGE * (pageNumber - 1),
    POSTS_PER_PAGE * pageNumber
  );
  const pagination = {
    currentPage: pageNumber,
    totalPages: Math.ceil(posts.length / POSTS_PER_PAGE),
  };

  return {
    props: {
      posts,
      initialDisplayPosts,
      pagination,
    },
  };
};

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const PostPage: NextPageTypes.NextPageWithLayout<Props> = ({
  posts,
  initialDisplayPosts,
  pagination,
}) => {
  return (
    <>
      <PageSEO
        title={siteMetadata.title}
        description={siteMetadata.description}
      />
      {/* Hide on pages as it's really rather large */}
      {/* <BlogHero /> */}
      <main className="bg-gray-100 ">
        <div className="container-xl">
          <div className="py-48 md:py-100 lg:px-56 ">
            <div className="">
              <BlogList
                posts={posts}
                initialDisplayPosts={initialDisplayPosts}
                pagination={pagination}
              />
            </div>
          </div>
        </div>

        <CTASection className="bg-gray-100" />
      </main>
    </>
  );
};

PostPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout noTags>{page}</Layout>;
};

export default PostPage;
